import React from 'react';

type CountBandProps = { label?: string; value?: number | string; matches?: number; total?: number; detail: string };

export const CountBand: React.FC<CountBandProps> = ({ label = 'Live total', value, matches, total, detail }) => {
  const display = matches != null && total != null && matches !== total ? `${matches} of ${total}` : (matches ?? total ?? value ?? 0);
  return <section className="count" aria-label={`${detail}: ${display}`}><span>{label}</span><strong>{display}</strong><p>{detail}</p></section>;
};
